import api from '../api';

import { Grant, GrantLifecycleData } from './types';

export const fetchGrants = (companyId: string): Promise<Grant[]> =>
  api.get<Grant[]>(`v1/equity_liquidity/grant/?company_id=${companyId}`);

export const fetchGrantLifecycle = (grantId: string): Promise<GrantLifecycleData[]> =>
  api.get(`v1/equity_liquidity/grant/${grantId}/lifecycle/`);
